import { maxDelayDays, minDelayDays } from './constants'

export const isDelayDaysValid = value => {
  const delayDays = Number(value)

  return Number.isInteger(delayDays) && delayDays >= minDelayDays && delayDays <= maxDelayDays
}
